module.exports = __webpack_public_path__ + "93c2861dae25572c622d2f1a298083f4.svg";